import React, { useState, useEffect, useRef } from 'react'
import { Input, Button, Card, Modal, Form, message, Radio } from 'antd'
import { CheckOutlined } from '@ant-design/icons'
import {
  paginationInit,
  formatMessageNew,
  downLoadFileBlob,
  initValueAndLabel,
  uniqueFun,
  dateFormatYearMonthDayTime
} from '@/utils/common'
import dayjs from 'dayjs'
import {
  getWarehouseData,
  getShiptoList,
  saveWarehouseConfig,
  warehouseExport,
  getDropDownList
} from '@/services/rfid/rfidConfig/adcWarehouse'
import SearchBar from '@/components/searchbar/SearchBar'
import AntdTable from '@/components/table/AntdTable'
import { RETAG_LIST } from '@/utils/types'
const AdcWarehousePage = () => {
  const [newModalForm] = Form.useForm()
  const [tableList, setTableList] = useState([])
  const [queryFlag, setQueryFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const [shipToList, setShipToList] = useState([])
  const [visibleFlag, setVisibleFlag] = useState(false)
  const [shipToRadioValue, setShipToRadioValue] = useState('')
  const mounting = useRef(false)
  let formRef = useRef(null)
  let editItemInfo = useRef({})
  let editItemFlag = useRef(false)
  let searchListInit = [
    {
      type: 'select',
      label: 'languageObj.adcWarehouse.ownerGroup',
      key: 'ownerGroupList',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.adcWarehouse.warehouseCity',
      key: 'warehouseList',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.adcWarehouse.shipto',
      key: 'shipToList',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.adcWarehouse.defaultShipto',
      key: 'defaultShipToList',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: RETAG_LIST,
      spans: {
        xl: 8,
        xxl: 8
      }
    }
  ]
  const [searchList, setSearchList] = useState(searchListInit)
  const tableColumns = [
    {
      title: formatMessageNew('languageObj.adcWarehouse.siteType'),
      dataIndex: 'siteType'
    },
    {
      title: formatMessageNew('languageObj.adcWarehouse.ownerGroup'),
      dataIndex: 'ownerGroup'
    },
    {
      title: formatMessageNew('languageObj.adcWarehouse.warehouseCity'),
      dataIndex: 'warehouse'
    },
    {
      title: formatMessageNew('languageObj.adcWarehouse.shipto'),
      dataIndex: 'shipTo'
    },
    {
      title: formatMessageNew('languageObj.adcWarehouse.defaultShipto'),
      dataIndex: 'defaultShipTo',
      align: 'center',
      render: text => {
        return text ? <CheckOutlined style={{ color: '#52c41a' }} /> : null
      }
    },
    {
      title: formatMessageNew('languageObj.adcWarehouse.createTime'),
      dataIndex: 'createTime',
      render: text => {
        return <div>{text && dayjs(text).format(dateFormatYearMonthDayTime)}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.adcWarehouse.updateTime'),
      dataIndex: 'updateTime',
      render: text => {
        return <div>{text && dayjs(text).format(dateFormatYearMonthDayTime)}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.commonLocale.operation'),
      dataIndex: 'operation',
      align: 'center',
      render: (text, record) => (
        <div>
          <Button
            type="link"
            size="small"
            onClick={() => {
              addAndEditRecord(record)
            }}
          >
            {formatMessageNew('languageObj.commonLocale.edit')}
          </Button>
        </div>
      )
    }
  ]
  useEffect(() => {
    mounting.current && searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  useEffect(() => {
    getSelectOptions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const addAndEditRecord = record => {
    setVisibleFlag(true)
    setShipToRadioValue('')
    if (record) {
      editItemFlag.current = true
      record.warehouseCity = record.warehouse
      record.defaultShipTo = record.defaultShipTo ? record.shipTo : null
      // 查询shipto
      getShiptoListFun(record)
      editItemInfo.current = record
      newModalForm.setFieldsValue(record)
    } else {
      editItemFlag.current = false
      editItemInfo.current = {}
      newModalForm.resetFields()
    }
  }
  const getSelectOptions = () => {
    getDropDownList().then(res => {
      searchListInit.forEach(itemFirst => {
        let dt = res.resultData
        let arr = []
        if (itemFirst.key === 'ownerGroupList' || itemFirst.key === 'warehouseList' || itemFirst.key === 'shipToList') {
          if (itemFirst.key === 'ownerGroupList') {
            arr = dt.ownerGroupList || []
          }
          if (itemFirst.key === 'warehouseList') {
            arr = dt.warehouseList || []
          }
          if (itemFirst.key === 'shipToList') {
            arr = dt.shipToList || []
          }
          itemFirst.selectList = initValueAndLabel(uniqueFun(arr, 2))
        }
      })
      setSearchList([...searchListInit])
    })
  }
  const getShiptoListFun = record => {
    let params = {
      ownerGroup: record.ownerGroup,
      warehouse: record.warehouseCity
    }
    getShiptoList(params).then(res => {
      let dt = res.resultData
      setShipToList(initValueAndLabel(dt))
    })
  }
  const downLoadFun = () => {
    const params = {
      ...getParams()
    }
    warehouseExport(params).then(res => {
      downLoadFileBlob(res)
    })
  }
  const searchDataBtn = () => {
    mounting.current = true
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    mounting.current = true
    formRef && formRef.current.clearForm()
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }
  const getParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const params = {
      ...info
    }
    return params
  }
  const searchDataFun = () => {
    const params = {
      asc: true,
      orderByColumn: 'a.owner_group,a.warehouse_city',
      current: pagination.currentPage,
      size: pagination.pageSize,
      param: {
        ...getParams()
      }
    }
    getWarehouseData(params).then(res => {
      const dt = res.resultData
      setTableList(dt.records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }
  const handleUserOk = () => {
    newModalForm
      .validateFields()
      .then(values => {
        const params = {
          ...values
        }
        if (editItemFlag.current) {
          params.id = editItemInfo.current.id
          saveWarehouseConfig(params).then(() => {
            message.success(formatMessageNew('languageObj.commonLocale.success'))
            setQueryFlag(!queryFlag)
            setVisibleFlag(false)
          })
        } else {
        }
      })
      .catch(errorInfo => {
        console.log('errorInfo', errorInfo)
      })
  }
  const handleUserCancel = () => {
    setVisibleFlag(false)
  }
  const radioChange = e => {
    setShipToRadioValue(e.target.value)
  }
  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar
            ref={formRef}
            searchList={searchList}
            showSearchBtn={true}
            showClearBtn={true}
            onSearch={searchDataBtn}
            onClear={searchClearDataBtn}
          />
        </div>
        <div className="content-container overflow_visible auto-mt20">
          <AntdTable
            dataSource={tableList}
            onDownload={downLoadFun}
            columns={tableColumns}
            pagination={pagination}
            onChange={handleTableChange}
          />
        </div>
      </Card>
      <Modal
        open={visibleFlag}
        maskClosable={false}
        className="nike_modal"
        width="40%"
        title={formatMessageNew('languageObj.commonLocale.edit')}
        onOk={handleUserOk}
        onCancel={handleUserCancel}
        destroyOnClose
      >
        <Form
          name="basic"
          form={newModalForm}
          labelCol={{
            span: 8
          }}
          wrapperCol={{
            span: 16
          }}
          initialValues={{}}
        >
          <Form.Item
            rules={[
              {
                required: true
              }
            ]}
            label={formatMessageNew('languageObj.adcWarehouse.ownerGroup')}
            name="ownerGroup"
          >
            <Input disabled />
          </Form.Item>

          <Form.Item
            rules={[
              {
                required: true
              }
            ]}
            label={formatMessageNew('languageObj.adcWarehouse.warehouseCity')}
            name="warehouseCity"
          >
            <Input disabled />
          </Form.Item>

          <Form.Item
            rules={[
              {
                required: true,
                message: `${formatMessageNew('languageObj.commonLocale.placeholderSelect')} ${formatMessageNew(
                  'languageObj.adcWarehouse.shipto'
                )}`
              }
            ]}
            label={formatMessageNew('languageObj.adcWarehouse.shipto')}
            name="defaultShipTo"
          >
            <Radio.Group onChange={radioChange}>
              {shipToList.map((item, idx) => {
                return (
                  <Radio value={item.value} key={idx}>
                    {editItemInfo.current.shipTo === item.value && !shipToRadioValue ? (
                      <div className="highlight">{item.label}</div>
                    ) : (
                      <div>{item.label}</div>
                    )}
                  </Radio>
                )
              })}
            </Radio.Group>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}
export default AdcWarehousePage
